import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { personSchema } from './schema';

const PersonData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = personSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

PersonData.propTypes = {
  data: PropTypes.object,
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default PersonData;
